import React, { createContext, useState, useContext } from 'react';

// Create the context
const ThankYouMessageStatusContext = createContext();

// Create a provider component
export const ThankYouMessageStatusProvider = ({ children }) => {
    const [thankYouMessageStatus, setThankYouMessageStatus] = useState(false); // default false

    return (
        <ThankYouMessageStatusContext.Provider value={{ thankYouMessageStatus, setThankYouMessageStatus }}>
            {children}
        </ThankYouMessageStatusContext.Provider>
    );
};

// Custom hook to use the ThankYouMessageStatusContext
export const useThankYouMessageStatus = () => {
    return useContext(ThankYouMessageStatusContext);
};
